<template>
  <o-form :title="$t('core.approvers')"
          :url="'/api/system/user_approval_roles/' + $route.params.id + '?include=user'"
          class="ortic-form-horizontal"
          ref="form"
          @loaded="loaded">
    <template slot-scope="props">
      <b-row v-if="canRender">
        <b-col>
          <o-value-select :label="$t('core.user')" 
                          url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&per_page=99999" 
                          value-field="id" 
                          text-field="name"
                          v-model="props.item.user_id"/>
          <o-value-select :items="approvalRoles" 
                          :label="$t('core.approval_role')" 
                          :key="'approval-role-' + approvalRoles.length"
                          v-model="props.item.approval_role"/>
          <o-value-select :items="approvalRoleTypes" 
                          :label="$t('core.approval_role_type')" 
                          :key="'approval-role-type-' + approvalRoleTypes.length"
                          v-model="props.item.approval_role_type"/>
          <o-value-select :label="$t('core.region')" 
                          :items="regions"
                          value-field="value"
                          text-field="text"
                          v-model="props.item.region_id"/>
          <o-checkbox :label="$t('core.is_deputy')" v-model="props.item.is_deputy"/>
        </b-col>
        <b-col>
        </b-col>
      </b-row>
    </template>
  </o-form>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    approvalRoles: [],
    approvalRoleTypes: [],
    regions: [],
    enumValuesLoaded: false,
    regionsLoaded: false,
    formLoaded: false
  }),
  created() {
    // Fetch enum values from the database
    axios.get('/api/system/user_approval_roles/enum-values').then((response) => {
      this.approvalRoles = response.data.approval_roles
      // Add empty option for approval_role_type
      this.approvalRoleTypes = [
        {value: '', text: '-'},
        ...response.data.approval_role_types
      ]
      this.enumValuesLoaded = true
    }).catch((error) => {
      console.error('Error fetching enum values:', error)
    })

    // Fetch regions and add empty option
    axios.get('/api/system/regions?sortBy=region&per_page=99999').then((response) => {
      this.regions = [
        {value: null, text: '-'},
        ...response.data.data.map(region => ({
          value: region.id,
          text: region.region
        }))
      ]
      this.regionsLoaded = true
    }).catch((error) => {
      console.error('Error fetching regions:', error)
      this.regionsLoaded = true // Still allow form to render even if regions fail to load
    })
  },
  computed: {
    canRender() {
      return this.enumValuesLoaded && this.regionsLoaded && this.formLoaded
    }
  },
  methods: {
    loaded(item) {
      this.formLoaded = true
      // Force update of dropdowns after form loads by triggering reactivity
      this.$nextTick(() => {
        // The form item values should now be available, and enum values are already loaded
        // This ensures the dropdowns can match the values
      })
    }
  }
}
</script>

